var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.page.categories,"item-text":"name","item-value":"id","label":"Catégorie forcée","loading":_vm.page.loading,"no-data-text":!_vm.forceSiteId
      ? 'Sélectionnez un site'
      : _vm.page.loading
      ? 'Chargement…'
      : 'Aucune catégorie trouvée',"outlined":"","dense":_vm.dense,"hide-details":"","clearable":"","disabled":!_vm.forceSiteId},model:{value:(_vm.categoryId),callback:function ($$v) {_vm.categoryId=$$v},expression:"categoryId"}})}
var staticRenderFns = []

export { render, staticRenderFns }